import { memo } from 'react';

import makeMonthViewContext from '../../services/contextAdaptor';
import createMonthView from '../MonthView/createMonthView';

import type { MonthViewContextOptions } from '../../services/contextAdaptor/types';

const MonthViewContainer = memo((contextOptions: MonthViewContextOptions) => {
  const context = makeMonthViewContext(contextOptions);
  return createMonthView(context);
});

export default MonthViewContainer;
